import { DeviceTrackingLogTypeEnum } from '@/api/apis/route';

export enum DeviceTrackingValueEnum {
  STA = 'STA',
  ETA = 'ETA',
  PTA = 'PTA',
  Device = 'Device',
  TripNumber = 'TripNumber',
  TailNumber = 'TailNumber',
  IsCompleted = 'IsCompleted',
  LocationType = 'LocationType',
  WaitDuration = 'WaitDuration',
  DisplayLocationTracking = 'DisplayLocationTracking',
  DisplayETA = 'DisplayETA',
}

export const DEVICE_TRACKING_LOG_NAME: Record<DeviceTrackingLogTypeEnum, string> = {
  [DeviceTrackingLogTypeEnum.AirTrackingNodeAddedLogModel]: 'Air Tracking Node: Added',
  [DeviceTrackingLogTypeEnum.AirTrackingNodeEtaModifiedLogModel]: 'Air Tracking Node: ETA Modified',
  [DeviceTrackingLogTypeEnum.AirTrackingNodeModifiedLogModel]: 'Air Tracking Node: Modified',
  [DeviceTrackingLogTypeEnum.AirTrackingNodeRemovedLogModel]: 'Air Tracking Node: Removed',
  [DeviceTrackingLogTypeEnum.AirTrackingNodeStaModifiedLogModel]: 'Air Tracking Node: STA Modified',
  [DeviceTrackingLogTypeEnum.ArrivalTimeRecalculatedLogModel]: 'Arrival Time Recalculated',
  [DeviceTrackingLogTypeEnum.DeviceTrackingCreatedLogModel]: 'Device Tracking Created',
  [DeviceTrackingLogTypeEnum.DisplaySettingsModifiedLogModel]: 'Display Settings Modified',
  [DeviceTrackingLogTypeEnum.DisplaySettingsResetLogModel]: 'Display Settings Reset',
  [DeviceTrackingLogTypeEnum.GroundTrackingCheckpointCompletedLogModel]: 'Ground Tracking Node: Checkpoint Completed',
  [DeviceTrackingLogTypeEnum.GroundTrackingNodeCompletedLogModel]: 'Ground Tracking Node: Completed',
  [DeviceTrackingLogTypeEnum.GroundTrackingNodeAddedLogModel]: 'Ground Tracking Node: Added',
  [DeviceTrackingLogTypeEnum.GroundTrackingNodeEtaModifiedLogModel]: 'Ground Tracking Node: ETA Modified',
  [DeviceTrackingLogTypeEnum.GroundTrackingNodeModifiedLogModel]: 'Ground Tracking Node: Modified',
  [DeviceTrackingLogTypeEnum.GroundTrackingNodeRemovedLogModel]: 'Ground Tracking Node: Removed',
};

export const LOG_VALUE_NAME: Record<DeviceTrackingValueEnum, string> = {
  [DeviceTrackingValueEnum.STA]: 'STA2',
  [DeviceTrackingValueEnum.ETA]: 'ETA',
  [DeviceTrackingValueEnum.PTA]: 'STA1',
  [DeviceTrackingValueEnum.Device]: 'Device',
  [DeviceTrackingValueEnum.TailNumber]: 'Tail Number',
  [DeviceTrackingValueEnum.IsCompleted]: 'Checkpoint completed',
  [DeviceTrackingValueEnum.LocationType]: 'Location Type',
  [DeviceTrackingValueEnum.WaitDuration]: 'Wait Duration',
  [DeviceTrackingValueEnum.DisplayLocationTracking]: 'Show Location Tracking',
  [DeviceTrackingValueEnum.DisplayETA]: 'Show ETA',
  [DeviceTrackingValueEnum.TripNumber]: 'Trip Number',
};
